import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";

/*
** From https://github.com/egoist/vue-no-ssr
** With the authorization of @egoist
*/
import NoSsr from 'vue-no-ssr';
export default _objectSpread({}, NoSsr, {
  name: 'NoSsr'
});